export class PropPropertyHeader {
  Proh_PropertyIdentity: number;
  Proh_PropertyId: string;
  Proh_CommonRefNo: string;
  Proh_PropertyTypeID: string;
  Proh_PropertyName: string;
  Proh_Address1: string;
  Proh_Address2: string;
  Proh_Address3: string;
  Proh_Address4: string;
  Proh_PostCode: string;
}
